export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen py-12 lg:py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto">
        <p className="text-xs uppercase tracking-[0.2em] text-[#D4AF37] mb-4">Legal</p>
        <h1 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight text-[#F5F5F0] mb-2">
          Privacy Policy
        </h1>
        <p className="text-[#71717A] text-sm mb-12">Last updated: September 2, 2026</p>

        <div className="space-y-10 text-[#A1A1AA] leading-relaxed">
          <p>
            Mortal Works ("we", "us", or "our") operates the website mortalworks.art.
            This Privacy Policy explains how we collect, use, and protect your information
            when you visit our website or use our services.
          </p>

          <section>
            <h2 className="font-serif text-xl text-[#F5F5F0] mb-3">Information We Collect</h2>
            <p>
              We may collect basic information such as your name, email address, and any
              messages you send us when you contact us or make a purchase.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-xl text-[#F5F5F0] mb-3">How We Use Your Information</h2>
            <p>
              We use your information only to respond to you, process orders, and improve our website.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-xl text-[#F5F5F0] mb-3">Sharing of Information</h2>
            <p>
              We do not sell or share your personal information with third parties, except
              when necessary to process payments or when required by law.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-xl text-[#F5F5F0] mb-3">Cookies</h2>
            <p>Our website may use basic cookies to help it work properly.</p>
          </section>

          <section>
            <h2 className="font-serif text-xl text-[#F5F5F0] mb-3">Your Rights</h2>
            <p>
              You can contact us at any time to ask about, update, or delete your information.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-xl text-[#F5F5F0] mb-3">Contact Us</h2>
            <p>
              If you have any questions about this Privacy Policy, please contact us
              through the contact form on mortalworks.art.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
